import { api } from '@/core/lib/api-client';
import { IGoogleSpreadsheet, ResponseType } from '@link-in-bio/domain';

export const getGoogleSpreadsheets = (linkInBioId: string): Promise<ResponseType<IGoogleSpreadsheet>> => {
  return api.get(`/google-spreadsheet/spreadsheets/${linkInBioId}`);
};
